import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
const PASSWORD_TYPE = 'password';
export default class Input extends React.Component {

  state = { value: this.props.value || '',
            error: '' };

  hasError = () => {
    return this.state.error;
  };

  componentWillMount = () => {
    this.setState({ type: this.props.type })
  };

  componentWillReceiveProps = newProps => {
    let newState = _.assign({}, this.state, newProps);
    this.setState(newState);
  };

  handleChange = e => {
    this.props.handleChange({[this.props.name]: e.target.value})
  };

  isPasswordType = () => {
    return this.props.type === PASSWORD_TYPE
  };

  handleChangeType = e => {
    if(this.state.type === PASSWORD_TYPE)
      this.setState({ type: 'text' });
    else
      this.setState({type: PASSWORD_TYPE})
  };

  isArray = () => {
    if(this.state.error)
      return Array.isArray(this.state.error.slice());
    else
      return false
  };

  render(){
    const {hideLabel, placeholder} = this.props;
    return(
        <div className={classNames({'input-holder': true,
                                    'socials-holder': this.props.social,
                                    'animate': true,
                                    'has-error': this.hasError(),
                                    'touched': this.state.value != ''}) }>
          <input id={this.props.name}
                 className="animate-input"
                 style={this.props.disabled ? {color: 'black', opacity: 0.54 } : {} }
                 type={this.state.type}
                 readOnly={this.props.readonly}
                 maxLength={this.props.maxlength}
                 required = {this.props.required}
                 value={this.state.value}
                 disabled={this.props.disabled}
                 placeholder={hideLabel ? placeholder : ""}
                 onChange={this.handleChange}/>
            <label className="animate-label"
                   style={{pointerEvents: 'none'}}
                   htmlFor={this.props.name}>{hideLabel ? "" : this.props.placeholder}</label>
            <span className="bar"/>
             { this.isPasswordType() &&
            <i onClick={this.handleChangeType}
              className={classNames({ icon: true,
                                      'ic-eye-icon': true,
                                      active: (this.state.type != PASSWORD_TYPE) })}/>}
            <span className="error-text">{this.isArray() ?  this.state.error.join(', ') : null}</span>
           {this.props.children}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/Input.jsx